import { formatTitleForUrl } from '@/utils/helpers';

export const ROUTES = {
  HOME: '/',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  SIGN_UP_SUCCESS: '/sign-up/success',
  BOOKING_EXPERT_DETAILS: (id: string) => `/booking/expert/${id}`,
  EXPERT_BOOKING_EXPERT_DETAILS: (id: string) => `/expert/booking/expert/${id}`,
  VIDEO_COURSE: (id: number | string, title: string, videoIndex?: number) => {
    const baseRoute = `/video-course/${id}/${formatTitleForUrl(title)}`;
    return videoIndex ? `${baseRoute}?video=${videoIndex}` : baseRoute;
  },
  VIDEO: (id: number | string, title: string) => `/video/${id}/${formatTitleForUrl(title)}`,
  CHAT: (id: string) => `/chat/${id}`,
  EXPERT_CHAT: (id: string) => `/expert/chat/${id}`,
  MESSAGES: '/messages',
  EXPERT_PAGE: (id: number) => `/experts/${id}`,
  EXPERTS: '/experts',
  LIBRARY: '/library',
  LIVE_COURSES: '/live-courses',
  PARTNERS: '/partners',
  BOOK_EXPERT: (id: string | number) => `/book/expert/${id}`,
  EXPERT_BOOKING: (id: string | number) => `/booking/expert/${id}`,
  ORIENTATION_CALL_BOOKING: (id: string | number) => `/booking/orientation-call/${id}`,
  EXPERT_ORIENTATION_CALL_BOOKING: (id: string | number) =>
    `/expert/booking/orientation-call/${id}`,
  EXPERT_RESCHEDULE_BOOKING: (expert_id: string, id: string) =>
    `/experts/${expert_id}/bookings/${id}/reschedule`,
  EXPERT_MEETING: (expert_id: string, id: string) => `/expert/${expert_id}/bookings/${id}/meeting`,
  EXPERT_LIVE_COURSE: (expert_id: string, id: string) =>
    `/expert/${expert_id}/bookings/${id}/live-course`,
  USER_EXPERT_SESSION_MEETING: (user_id: string, id: string) =>
    `/users/${user_id}/bookings/${id}/meeting`,
  USER_LIVE_COURSE: (id: string) => `/users/bookings/${id}/live-course`,
  BOOK_LIVE_COURSE: (bookingId: string | number) => `/booking/live-course/${bookingId}`,
  EXPERT_BOOK_LIVE_COURSE: (bookingId: string | number) =>
    `/expert/booking/live-course/${bookingId}`,
  BOOK_USER: (id: string | number) => `/expert/book/user/${id}`,
  ACUTE_HELP: '/acute-help',
  HELPCENTER: '/helpcenter',
  BOOKING_HISTORY: '/bookings',
  SETTINGS: '/settings',
  LOGOUT: '/logout',
  RESET_PASSWORD: '/sign-in/reset-password',
  EXPERT_DASHBOARD: '/expert/dashboard',
  EXPERT_DASHBOARD_MESSAGES: '/expert/messages',
  EXPERT_DASHBOARD_BOOKINGS: '/expert/bookings',
  RESCHEDULE_BOOKING: (id: string | number) => `/expert/reschedule/booking/${id}`,
  VERIFY_EMAIL: '/verify-email',
  ADMIN: '/admin',
  UNAUTHORIZED: '/unauthorized',
  DESIGN_SYSTEM_SIGN_IN: '/design-system/sign-in',
  OHS_HUB: '/ohs-hub',
  OHS_HUB_EMPLOYEES: '/ohs-hub/employees',
  OHS_HUB_FIRST_AID: '/ohs-hub/first-aid',
  OHS_HUB_FIRST_AID_DETAIL: (id: string) => `/ohs-hub/first-aid/${id}`,
  OHS_HUB_PREVENTION_REGISTER: '/ohs-hub/prevention-register',
  OHS_HUB_INSTRUCTIONS: '/ohs-hub/instructions',
  OHS_HUB_INSTRUCTIONS_DETAIL: (id: string) => `/ohs-hub/instructions/${id}`,
  OHS_HUB_PREVENTION_REGISTER_DETAIL: (id: string) => `/ohs-hub/prevention-register/${id}`,
  OHS_HUB_EMPLOYEE_PAGE: (id: string) => `/ohs-hub/employees/${id}`,
  MH_RISK_ASSESSMENT: '/ohs-hub/mh-risk-assessment',
  MH_RISK_ASSESSMENT_ENTRY: (entryId: string) => `/ohs-hub/mh-risk-assessment/${entryId}`,
  MH_RISK_ASSESSMENT_SURVEY: (surveyId: string) => `/ohs-hub/mh-risk-assessment/survey/${surveyId}`,

  MATERNITY_RISK_ASSESSMENT: '/ohs-hub/maternity-risk-assessment',
  MATERNITY_RISK_ASSESSMENT_QUESTIONNAIRE: (notificationId: string) =>
    `/ohs-hub/maternity-risk-assessment/${notificationId}/questionnaire`,
  MATERNITY_RISK_ASSESSMENT_ENTRY: (entryId: string) =>
    `/ohs-hub/maternity-risk-assessment/${entryId}`,
  QR_REDIRECT: (qrCode: string) => `/qr/${qrCode}`,
  EXTERNAL_FIRST_AID: (orgId: string) => `/external/first-aid/${orgId}`,
  INSTRUCTION_PUBLIC: (id: string) => `/instructions/${id}`,
};

export const getUrlWithOrigin = (route: string) => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${route}`;
  }
  // Server-side fallback: OHS Hub routes belong on Ginione, everything else on Bloom
  const origin = route.startsWith('/ohs-hub')
    ? (process.env.NEXT_PUBLIC_GINIONE_ORIGIN ?? '')
    : (process.env.NEXT_PUBLIC_BLOOM_ORIGIN ?? '');
  return `${origin}${route}`;
};
